import { IonButton } from "@ionic/react";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  CompleteTest,
  CompleteTestPhase,
} from "../../services/AssessmentsService";
import { useRecoilState } from "recoil";
import {
  PatientState,
  currentAssessmentState,
  selectedAssessmentState,
} from "../../data/atoms";
import {
  convertDOBintoAge,
  formatAMPM,
  getCurrentDay,
  getLocalStringDate,
  testTypeMappings,
} from "../../utils/sharedFunction";
import { Assessment } from "../../models/AssessmentRelated/Assessment";
import { v4 as uuidv4 } from "uuid";
import { ASSESSMENT_STATUSES } from "../../movenet/params";
import { calculateOverallScores } from "../../vision-algo/mCTSIB_score_calculations";

interface Props {
  setShowModal2: Function;
  assessmentCompleteModalText: String;
  onChildClick: Function;
}

const AssessmentCompleteModal: React.FC<Props> = ({
  setShowModal2,
  assessmentCompleteModalText,
  onChildClick,
}) => {
  let history = useHistory();

  const [currentAssessment, setcurrentAssessmentState] = useRecoilState(
    currentAssessmentState,
  );
  const [patientAge, setpatientAge] = useState(0);
  const [date, setDate] = useState(getCurrentDay());
  const [time, setTime] = useState(formatAMPM(new Date()));
  const [patientInfo, setPatientInfo] = useRecoilState(PatientState);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [selectedAssessmentType, setSelectedAssessmentType] = useRecoilState(
    selectedAssessmentState,
  );
  const RedoTest = () => {
    setShowModal2(false);
    onChildClick("Redo");
  };
  // const ViewResult = () => {
  //   setShowModal2(false);
  //   history.push("/assessment-notes");
  // };
  const end_task = () => {
    setShowModal2(false);
    history.push("/patient-page");
  };
  const ViewResult = () => {
    debugger;
    setIsSubmitted(true);
    let localtime = new Date(
      new Date().setHours(
        new Date().getHours() - new Date().getTimezoneOffset() / 60,
      ),
    ).toISOString();

    const testJson = JSON.parse(currentAssessment.testJson)?.root;

    console.log("Current Assessment Test JSON:", testJson);

    let assessmentType = testJson?.test_type;
    let testTypeValue: number | undefined;
    testTypeValue = testTypeMappings[assessmentType];

    console.log("Test type value in assessment complete modal:", testTypeValue);

    debugger;

    // Check if it's a functional reach test (TestType.reach = 2)
    if (testJson?.test_type === "functional_Reach") {
      try {
        const testJsonData = JSON.parse(currentAssessment.testJson)?.root;
        const phases = testJsonData?.phases || [];

        // Create phases sequentially
        const createPhasesSequentially = async () => {
          const phaseIds = [];

          for (const phase of phases) {
            const phaseData = {
              test_type: testJsonData.test_type,
              start_time: testJsonData.start_time,
              end_time: testJsonData.end_time,
              ...phase,
            };

            const phaseJson = JSON.stringify(phaseData);

            const jsonstrwithroot = { root: JSON.parse(phaseJson) };

            // const overallScores = calculateOverallScores([phaseData]);

            const result: any = await CompleteTestPhase({
              TestId: currentAssessment.testId,
              AdmissionDateUTC: localtime,
              LocalDateTime: localtime,
              UTCDateTime: localtime,
              StartTime: localtime,
              StartTimeUTC: localtime,
              EndTime: localtime,
              EndTimeUTC: localtime,
              TestJson: JSON.stringify(jsonstrwithroot),
              // ScoreTags: JSON.stringify(overallScores.scores),
            });

            phaseIds.push(result.data.id);
          }

          // Use the last phase ID for CompleteTest
          const lastPhaseId = phaseIds[phaseIds.length - 1];

          setcurrentAssessmentState((prevState: Assessment) => ({
            ...prevState,
            phaseId: lastPhaseId,
          }));

          return lastPhaseId;
        };

        createPhasesSequentially()
          .then((lastPhaseId) => {
            console.log(
              "Test look up id in currentAssessment.assessmentType",
              currentAssessment.assessmentType,
            );
            console.log("Test look up id in testTypeValue", testTypeValue);

            const testJsonData = JSON.parse(currentAssessment.testJson)?.root;

            console.log("Test JSON data for score calculation:", testJsonData);
            // const finalScores = calculateOverallScores(
            //   testJsonData?.phases || [],
            // );

            // console.log(
            //   "Final calculated scores for functional reach:",
            //   finalScores,
            // );
            CompleteTest({
              TestId: currentAssessment?.testId,
              VisitId: currentAssessment?.visitId,
              PatientId: localStorage.getItem("patientServerID"),
              TestLookupId:
                currentAssessment.assessmentType !== undefined ||
                currentAssessment.assessmentType !== null ||
                currentAssessment.assessmentType !== 0
                  ? currentAssessment.assessmentType
                  : testTypeValue !== undefined || testTypeValue !== null
                    ? testTypeValue
                    : 0,
              MasterTestId: currentAssessment.masterTestId,
              PhaseId: lastPhaseId,
            })
              .then(async (res: any) => {
                if (res.data.responseCode == 1) {
                  let summaryDetail = {
                    date: date,
                    dateFormat: getLocalStringDate(),
                    time: time,
                  };
                  setpatientAge(convertDOBintoAge(new Date(patientInfo?.dob)));
                  let assessmentSummaryArray = JSON.parse(
                    localStorage.getItem("summaryDetail") || "[]",
                  );
                  let getJSONSummary = JSON.parse(
                    localStorage.getItem("Assesment Summary")!,
                  );
                  let assessmentID = uuidv4();
                  let patientServerID = localStorage.getItem("patientServerID")
                    ? localStorage.getItem("patientServerID")
                    : "000";
                  let patientName = localStorage.getItem("patientName")
                    ? localStorage.getItem("patientName")!
                    : "Name Required";
                  getJSONSummary = {
                    assessmentID: assessmentID,
                    patientServerID: patientServerID,
                    patientName: patientName,
                    patientAge: patientAge,
                    ...summaryDetail,
                    ...getJSONSummary,
                  };
                  assessmentSummaryArray.push(getJSONSummary);
                  localStorage.setItem(
                    "summaryDetail",
                    JSON.stringify(assessmentSummaryArray),
                  );
                  localStorage.setItem(
                    "selectedAssesment",
                    JSON.stringify(assessmentID),
                  );
                  setTimeout(() => {
                    history.replace("/patient-assessment-summary", {
                      pageHeaderText: "Full Visit Summary",
                      isAssessmentCompleted: true,
                    });
                  }, 200);
                }
              })
              .catch((err) => {
                console.error(err);
              });
          })
          .catch((err) => {
            console.error("Error creating functional reach phases:", err);
          });
      } catch (err) {
        console.error("Error parsing functional reach test JSON:", err);
      }
    } else if (
      testJson?.phases !== null &&
      testJson?.phases !== undefined &&
      testJson?.phases.length > 0 &&
      testJson?.phases[0].test_type === "ctsib"
    ) {
      try {
        const testJsonData = JSON.parse(currentAssessment.testJson)?.root;
        const phases = testJsonData?.phases || [];
        // const phases = Array.isArray(testJsonData) ? testJsonData : [];

        const createPhasesSequentially = async () => {
          const phaseIds = [];
          for (const phase of phases) {
            const phaseData = {
              test_type: phase.test_type,
              start_time: testJsonData.start_time,
              end_time: testJsonData.end_time,
              ...phase,
            };
            const jsonstrwithroot = { root: phaseData };

            const result: any = await CompleteTestPhase({
              TestId: currentAssessment.testId,
              AdmissionDateUTC: localtime,
              LocalDateTime: localtime,
              UTCDateTime: localtime,
              StartTime: localtime,
              StartTimeUTC: localtime,
              EndTime: localtime,
              EndTimeUTC: localtime,
              TestJson: JSON.stringify(jsonstrwithroot),
            });
            phaseIds.push(result.data.id);
          }
          const lastPhaseId = phaseIds[phaseIds.length - 1];
          setcurrentAssessmentState((prevState: Assessment) => ({
            ...prevState,
            phaseId: lastPhaseId,
          }));
          return lastPhaseId;
        };

        createPhasesSequentially().then((lastPhaseId) => {
          const mctsibPhases = phases;

          console.log("mCTSIB Phases for score calculation:", mctsibPhases);

          const finalScores: any = calculateOverallScores(mctsibPhases);

          console.log("Final calculated scores for mCTSIB:", finalScores);

          CompleteTest({
            TestId: currentAssessment?.testId,
            VisitId: currentAssessment?.visitId,
            PatientId: localStorage.getItem("patientServerID"),
            // TestLookupId:
            //   currentAssessment.assessmentType || testTypeValue || 0,
            TestLookupId: 1,
            MasterTestId: currentAssessment.masterTestId,
            PhaseId: lastPhaseId,
            ScoreTags: JSON.stringify(finalScores.scores),
          }).then(async (res: any) => {
            if (res.data.responseCode == 1) {
              let summaryDetail = {
                date: date,
                dateFormat: getLocalStringDate(),
                time: time,
              };
              setpatientAge(convertDOBintoAge(new Date(patientInfo?.dob)));
              let assessmentSummaryArray = JSON.parse(
                localStorage.getItem("summaryDetail") || "[]",
              );
              let getJSONSummary = JSON.parse(
                localStorage.getItem("Assesment Summary")!,
              );
              let assessmentID = uuidv4();
              let patientServerID = localStorage.getItem("patientServerID")
                ? localStorage.getItem("patientServerID")
                : "000";
              let patientName = localStorage.getItem("patientName")
                ? localStorage.getItem("patientName")!
                : "Name Required";
              getJSONSummary = {
                assessmentID: assessmentID,
                patientServerID: patientServerID,
                patientName: patientName,
                patientAge: patientAge,
                ...summaryDetail,
                ...getJSONSummary,
              };
              assessmentSummaryArray.push(getJSONSummary);
              localStorage.setItem(
                "summaryDetail",
                JSON.stringify(assessmentSummaryArray),
              );
              localStorage.setItem(
                "selectedAssesment",
                JSON.stringify(assessmentID),
              );
              setTimeout(() => {
                history.replace("/patient-assessment-summary", {
                  pageHeaderText: "Full Visit Summary",
                  isAssessmentCompleted: true,
                });
              }, 200);
            }
          });
        });
      } catch (err) {
        console.error("Error processing mCTSIB phases:", err);
      }
    } else {
      // Original logic for all other assessment types
      CompleteTestPhase({
        TestId: currentAssessment.testId,
        AdmissionDateUTC: localtime,
        LocalDateTime: localtime,
        UTCDateTime: localtime,
        StartTime: localtime,
        StartTimeUTC: localtime,
        EndTime: localtime,
        EndTimeUTC: localtime,
        TestJson: currentAssessment.testJson,
      })
        .then((result: any) => {
          setcurrentAssessmentState((prevState: Assessment) => ({
            ...prevState,
            phaseId: result.data.id,
          }));

          console.log(
            "Test look up id in currentAssessment.assessmentType",
            currentAssessment.assessmentType,
          );
          console.log("Test look up id in testTypeValue", testTypeValue);

          CompleteTest({
            TestId: currentAssessment?.testId,
            VisitId: currentAssessment?.visitId,
            //  IsInComplete: currentAssessment.testId,
            PatientId: localStorage.getItem("patientServerID"),
            // TestLookupId:  TestType.gait,
            TestLookupId:
              currentAssessment.assessmentType !== undefined ||
              currentAssessment.assessmentType !== null ||
              currentAssessment.assessmentType !== 0
                ? currentAssessment.assessmentType
                : testTypeValue !== undefined || testTypeValue !== null
                  ? testTypeValue
                  : 0,
            MasterTestId: currentAssessment.masterTestId,
            PhaseId: result.data.id,
          })
            .then(async (res: any) => {
              if (res.data.responseCode == 1) {
                let summaryDetail = {
                  date: date,
                  dateFormat: getLocalStringDate(),
                  time: time,
                };
                setpatientAge(convertDOBintoAge(new Date(patientInfo?.dob)));
                let assessmentSummaryArray = JSON.parse(
                  localStorage.getItem("summaryDetail") || "[]",
                );
                let getJSONSummary = JSON.parse(
                  localStorage.getItem("Assesment Summary")!,
                );
                let assessmentID = uuidv4();
                let patientServerID = localStorage.getItem("patientServerID")
                  ? localStorage.getItem("patientServerID")
                  : "000";
                let patientName = localStorage.getItem("patientName")
                  ? localStorage.getItem("patientName")!
                  : "Name Required";
                getJSONSummary = {
                  assessmentID: assessmentID,
                  patientServerID: patientServerID,
                  patientName: patientName,
                  patientAge: patientAge,
                  ...summaryDetail,
                  ...getJSONSummary,
                };
                assessmentSummaryArray.push(getJSONSummary);
                localStorage.setItem(
                  "summaryDetail",
                  JSON.stringify(assessmentSummaryArray),
                );
                localStorage.setItem(
                  "selectedAssesment",
                  JSON.stringify(assessmentID),
                );
                setTimeout(() => {
                  history.replace("/patient-assessment-summary", {
                    pageHeaderText: "Full Visit Summary",
                    isAssessmentCompleted: true,
                  });
                }, 200);
              }
            })
            .catch((err) => {
              console.error(err);
            });
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  function handleClick() {
    //route on basis of action type
    setShowModal2(false);
    history.push("/assessment-notes");
  }

  return (
    <>
      {ASSESSMENT_STATUSES.assessment_error ? (
        <div className="assesment-error-modal">
          <div className="align-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="126"
              height="127"
              viewBox="0 0 126 127"
              fill="none"
            >
              <path
                d="M56.4095 85.16C56.4095 81.6929 59.2202 78.8822 62.6873 78.8822H63.3151C66.7822 78.8822 69.5929 81.6929 69.5929 85.16V85.7878C69.5929 89.2549 66.7822 92.0656 63.3151 92.0656H62.6873C59.2202 92.0656 56.4095 89.2549 56.4095 85.7878V85.16Z"
                fill="#890029"
              />
              <path
                d="M69.2777 41.2156C69.2777 37.7484 66.4671 34.9378 63 34.9378C59.5328 34.9378 56.7222 37.7484 56.7222 41.2156V66.3267C56.7222 69.7938 59.5328 72.6045 63 72.6045C66.4671 72.6045 69.2777 69.7938 69.2777 66.3267V41.2156Z"
                fill="#890029"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M33.2982 4.40009C35.6528 2.04547 38.8464 0.722656 42.1763 0.722656H83.8236C87.1535 0.722656 90.3471 2.04547 92.7017 4.4001L122.1 33.7987C124.455 36.1533 125.778 39.3469 125.778 42.6768V84.3241C125.778 87.654 124.455 90.8476 122.1 93.2022L92.7017 122.601C90.3471 124.955 87.1535 126.278 83.8236 126.278H42.1763C38.8464 126.278 35.6528 124.955 33.2982 122.601L3.8996 93.2022C1.54498 90.8475 0.222168 87.654 0.222168 84.324V42.6768C0.222168 39.3469 1.54498 36.1533 3.8996 33.7987L33.2982 4.40009ZM83.8236 13.2782L42.1763 13.2782L12.7777 42.6768L12.7777 84.324L42.1763 113.723L83.8236 113.723L113.222 84.3241V42.6768L83.8236 13.2782Z"
                fill="#890029"
              />
            </svg>
            <h1 className="assesment-modal-label mb-0">Assessment Error</h1>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "5px" }}
            >
              <p
                style={{ fontWeight: "500", fontSize: "25px" }}
                className="assesment-modal-desc"
              >
                Unable to complete the
              </p>
              <p
                style={{ fontWeight: "500", fontSize: "25px" }}
                className="assesment-modal-desc mt-0"
              >
                assessment - please exit
              </p>
              <p
                style={{ fontWeight: "500", fontSize: "25px" }}
                className="assesment-modal-desc mt-0"
              >
                the assessment to try again.
              </p>
            </div>
          </div>
          <div style={{ marginTop: "20px" }}>
            {/* id: the remote's NEXT presses this (assessment-page.tsx) */}
            <IonButton
              id="btnAssessmentErrorDiscard"
              className="blue-outline-btn"
              onClick={() => {
                end_task();
              }}
              placeholder={undefined}
            >
              Discard & Redo
            </IonButton>
            <IonButton
              className="blue-btn"
              disabled={isSubmitted}
              onClick={() => {
                ViewResult();
              }}
              placeholder={undefined}
            >
              View Results
            </IonButton>
          </div>
        </div>
      ) : (
        // <IonContent placeholder={undefined}>
        <div className="assessmet-complete-wrap">
          <svg
            width="126"
            height="127"
            viewBox="0 0 126 127"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M63 120C94.2041 120 119.5 94.7041 119.5 63.5C119.5 32.2959 94.2041 7 63 7C31.7959 7 6.5 32.2959 6.5 63.5C6.5 94.7041 31.7959 120 63 120Z"
              fill="#218448"
              stroke="#218448"
              strokeWidth="12.5556"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M81.8333 50.9445L56.7222 76.0556L44.1666 63.5"
              stroke="white"
              strokeWidth="12.5556"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ fontWeight: "700", fontSize: "64px" }}>
              Assessment{" "}
            </div>
            <div style={{ fontWeight: "700", fontSize: "64px" }}>
              Complete!{" "}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "30px",
              margin: "20px",
            }}
          >
            {/* ids: the remote's REWIND / NEXT press these (assessment-page.tsx) */}
            <IonButton
              id="btnAssessmentCompleteRedo"
              className="blue-outline-btn"
              onClick={() => {
                RedoTest();
              }}
              placeholder={undefined}
            >
              Discard & Redo
            </IonButton>
            <IonButton
              id="btnAssessmentCompleteViewResults"
              className="blue-btn"
              disabled={isSubmitted}
              onClick={() => {
                ViewResult();
              }}
              placeholder={undefined}
            >
              View Results
            </IonButton>
          </div>
        </div>
        // </IonContent>
      )}
    </>
  );
};

export default AssessmentCompleteModal;
